import GenererCarte from '@/components/carte/GenererCarte';

export default [
    {
        path: '/generer-carte',
        name: 'carte',
        component: GenererCarte
    }
]